<template>
  <div>
    <div id="inboxContent">
      <div class="checkChangeBox">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            :label="$t('messageBox.unreadMessage')"
            name="first"
          ></el-tab-pane>
          <el-tab-pane
            :label="$t('messageBox.readMessage')"
            name="second"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div class="messageTable" id="mesasgeTableOutBox">
        <el-table
          :empty-text="$t('messageBox.empty')"
          :data="tableData"
          header-cell-class-name="tableThStyle"
          :show-header="false"
        >
          <el-table-column>
            <template slot-scope="scope">
              <div class="messageContentBox" @click="readMessage(scope.row)">
                <div class="messageIcon"></div>
                <div>
                  <div
                    :style="{
                      color: getMessageColor(scope.row.type),
                    }"
                  >
                    <i
                      :class="
                        scope.row.readStatus
                          ? 'iconfont icon-duanxinyidu'
                          : 'el-icon-message'
                      "
                    ></i>
                    <span style="margin-left: 5px">{{
                      $t("messageBox." + scope.row.type)
                    }}</span>
                  </div>
                </div>
                <!-- <div class="titleBox">{{ scope.row.title }}</div> -->
                <div class="titleBox">{{ getTitle(scope.row) }}</div>
                <div class="createTimeBox">
                  {{ dataToString(scope.row.createTime) }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="noMoreBox" v-show="noMore && !isEmpty(this.tableData)">
          {{ $t("messageBox.noMore") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dataToString, isEmpty } from "@/utils/utils";
// import {cloneDeep} from "lodash"
export default {
  created() {
    this.activeName = this.$store.state.config.inboxStatus;
  },
  data() {
    return {
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pageSizeOption: [10, 20, 30, 50],
      },
      tableData: [],
      searchData: {},

      activeName: "",
      loading: false,
      noMore: false,
      // 距离底部多少像素开始查询
      distance: 50,

      // 查询定时器
      searchTimer: "",
      lastScrollTime: "",
    };
  },
  mounted() {
    let inboxContentDom = document.getElementById("mesasgeTableOutBox");
    if (!isEmpty(inboxContentDom?.scroll)) {
      // 时间监听执行的炒鸡频繁， 需要节流, 在this.mesasgeLoad 处理
      window.addEventListener("scroll", this.messageLoad, true);
    }
  },
  methods: {
    isEmpty,
    dataToString,
    searchFun() {
      this.searchData = {
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        createTimeSort: "DESC",
      };
      this.activeName == "first"
        ? (this.searchData.readStatus = false)
        : (this.searchData.readStatus = true);
      console.log(this.searchData);
      return new Promise((resolve, reject) => {
        this.$httpList
          .getInboxMessageList(this.searchData)
          .then((res) => {
            if (res.resultCode == 1001) {
              console.log(res);
              this.tableData = res.data.pageData;
              this.pagination.total = res.data.count;
              if (this.searchData.readStatus == false) {
                this.$store.commit("wsStore/changeCount", res.data.count);
              }
              resolve(res);
            }
          })
          .catch((err) => reject(err));
      });
    },
    // 更新表格中所有数据
    updateTableData() {
      // 已读 不进行更新  ，不存在状态改变
      if (!this.activeName == "first") {
        return;
      }
      this.searchData = {
        pageNum: 1,
        pageSize: this.pagination.currentPage * this.pagination.pageSize,
        createTimeSort: "DESC",
      };
      this.activeName == "first"
        ? (this.searchData.readStatus = false)
        : (this.searchData.readStatus = true);
      return new Promise((resolve, reject) => {
        this.$httpList
          .getInboxMessageList(this.searchData)
          .then((res) => {
            if (res.resultCode == 1001) {
              console.log(res);
              this.tableData = res.data.pageData;
              this.pagination.total = res.data.count;
              if (this.searchData.readStatus == false) {
                this.$store.commit("wsStore/changeCount", res.data.count);
              }
              resolve(res);
            }
          })
          .catch((err) => reject(err));
      });
    },
    handleSizeChange() {
      this.pagination.currentPage = 1;
      this.searchData.pageNum = this.pagination.currentPage;
      this.searchData.pageSize = this.pagination.pageSize;
      this.noMore = false;
      this.searchFun();
    },

    readMessage(data) {
      //  如果当前为空 ，表明当前没有消息要读   ，直接进入读消息状态
      let inboxDetailDialog = this.$store.state.config.inboxDetailDialog;
      if (!isEmpty(inboxDetailDialog) && inboxDetailDialog.show == false) {
        this.$store.commit("config/changeInboxDetailDialog", {
          show: true,
          id: data.id,
        });
      } else {
        // 表明当前有正在阅读的消息    ，不可打开
        this.$notify.warning(this.$t("messageBoxPromptMessage.inReading"));
      }
    },
    dialogBeforeClose(done) {
      console.log("消息详情关闭");
      done();
    },
    handleClick(tab, event) {
      console.log(tab, event);
      console.log(this.activeName);
      this.handleSizeChange();
      this.$store.commit("config/changeInboxStatus", this.activeName);
    },
    messageLoad() {
      let messageBodyBoxDom = document.getElementById("mesasgeTableOutBox");
      console.log(messageBodyBoxDom.scrollTop);
      if (this.loading == true) {
        // 正在加载或没有更多，不触发
        return;
      }
      if (this.noMore == true) {
        return;
      }
      if (
        messageBodyBoxDom.scrollHeight -
          messageBodyBoxDom.scrollTop -
          this.distance <=
        messageBodyBoxDom.clientHeight
      ) {
        // 正在加载
        this.loading = true;

        this.pagination.currentPage++;

        this.searchData = {
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          createTimeSort: "DESC",
        };
        this.activeName == "first"
          ? (this.searchData.readStatus = false)
          : (this.searchData.readStatus = true);

        new Promise((resolve, reject) => {
          this.$httpList
            .getInboxMessageList(this.searchData)
            .then((res) => {
              if (res.resultCode == 1001) {
                if (!isEmpty(res.data.pageData)) {
                  this.tableData.push(...res.data.pageData);
                  this.pagination.total = res.data.count;
                  if (this.searchData.readStatus == false) {
                    this.$store.commit("wsStore/changeCount", res.data.count);
                  }
                  if (res.data.pageData.length < 10) {
                    this.noMore = true;
                  }
                } else {
                  this.noMore = true;
                }
                resolve(res);
              }
            })
            .catch((err) => reject(err));
        }).then(() => {
          this.loading = false;
        });
      }
    },
    getTitle(data) {
      let language = this.$root.$i18n.locale;
      return data.title[language] ?? data.title["en"] ?? data.title["default"];
    },
    getMessageColor(data) {
      let color = "#303133";
      switch (data) {
        case "IMPORTANT_NOTICE":
          color = "#af231d";
          break;
        case "WARNING_NOTICE":
          color = "#b4c519";
          break;
        default:
          color = "#303133";
          break;
      }
      return color;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.messageLoad, true);
  },
};
</script>

<style lang="scss" scoped>
.noMoreBox {
  text-align: center;
  padding: 5px;
  color: #909399;
  word-break: break-all;
  font-size: 14px;
}
.checkChangeBox {
  margin-left: 10px;
  position: sticky;
  top: 0;
}

.messageTable {
  height: calc(100vh - 150px);
  overflow: auto;
}
.tableThStyle {
  background-color: #f5f5f5 !important;
  color: #585b61;
  font-size: 12px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
.basePaginationOut {
  position: fixed;
  bottom: 0px;
  background: #fff;
  text-align: right;
  padding-top: 7px;

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #015ac5;
    font-size: 14px;
    color: #fff;
    border-radius: 8px;
  }
}

.messageContentBox {
  display: flex;
  flex-direction: column;
  .titleBox {
    color: #303133;
    padding-right: 5px;
  }
  .createTimeBox {
    text-align: right;
    font-size: 12px;
    color: #b5b5b5;
  }
}

.messageTable::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}
.messageTable::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}
.messageTable::-webkit-scrollbar-thumb {
  background-color: #b5b5b5;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}
</style>
